module.exports = __webpack_public_path__ + "fonts/46328fa.woff";